import { render, staticRenderFns } from "./BatchMakeupForm.vue?vue&type=template&id=40e17897"
import script from "./BatchMakeupForm.vue?vue&type=script&lang=js"
export * from "./BatchMakeupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports